import styled from 'styled-components';

const ButtonElement = styled.button`
  appearance: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  background: ${({theme, $color}) => theme.button[$color].default.bg};
  color: ${({theme, $color}) => theme.button[$color].default.text};
  box-shadow: ${({theme, $color}) => theme.button[$color].default.shadow || 'none'};
  border-radius: 48px;
  border: none;
  font-size: 18px;
  line-height: 32px;
  font-weight: 600;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus {
    background: ${({theme, $color}) => theme.button[$color].hover.bg};
    color: ${({theme, $color}) => theme.button[$color].hover.text};
    box-shadow: ${({theme, $color}) => theme.button[$color].hover.shadow || 'none'};
  }

  &:active {
    background: ${({theme, $color}) => theme.button[$color].active.bg};
    color: ${({theme, $color}) => theme.button[$color].active.text};
    box-shadow: ${({theme, $color}) => theme.button[$color].active.shadow || 'none'};
    outline: none;
  }

  &[disabled],
  &[disabled]:hover {
    background: ${({theme, $color}) => theme.button[$color].disabled.bg};
    color: ${({theme, $color}) => theme.button[$color].disabled.text};
    box-shadow: ${({theme, $color}) => theme.button[$color].disabled.shadow || 'none'};
    cursor: default;
  }
`;

const Button = ({color = 'primary', children, ...rest}) => (
  <ButtonElement $color={color} {...rest}>{children}</ButtonElement>
);

export default Button;
